import { US_STATE_OPTIONS } from './contactConstants';

/**
 * Convert state name to 2-letter code
 */
export const toUSStateCode = (input) => {
  if (!input) return '';
  const trimmed = String(input).trim();
  if (trimmed.length === 2) return trimmed.toUpperCase();
  const match = US_STATE_OPTIONS.find(s => s.name.toLowerCase() === trimmed.toLowerCase());
  return match ? match.code : '';
};

/**
 * Format country display (convert 'United States of America' to 'US')
 */
export const formatCountryDisplay = (country) => {
  if (!country) return '';
  const countryLower = country.toLowerCase().trim();
  if (countryLower === 'united states of america' || countryLower === 'usa') {
    return 'US';
  }
  return country;
};

/**
 * Display country as US if value is 'United States of America'
 */
export const displayCountry = (country) => {
  return country && country.toLowerCase() === 'united states of america' ? 'US' : country || '';
};

/**
 * Validate email format
 */
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validate Nettles email domain restrictions
 */
export const validateNettlescsEmail = (email, sectionType, selectedGroup) => {
  if (!email) return true;
  const isNettlesDomain = email.toLowerCase().endsWith('@nettlescs.com');

  // Check if this is a Nettles Project Team contact
  const isNettlesTeam = sectionType === "Nettles Project Team" ||
    sectionType === "customerContacts" ||
    selectedGroup === "Nettles Project Team" ||
    selectedGroup === "customerContacts";

  if (isNettlesTeam) {
    return isNettlesDomain;
  }
  return !isNettlesDomain;
};

/**
 * Build comparable object from contact for change detection
 */
export const buildComparableFromSelected = (sc) => {
  const norm = (v) => (v == null ? '' : String(v).trim());
  return {
    FirstName: norm(sc.FirstName),
    LastName: norm(sc.LastName),
    AccountId: norm(sc.AccountId),
    Title: norm(sc.Title),
    Department: norm(sc.Department),
    Phone: norm(sc.Phone),
    MobilePhone: norm(sc.MobilePhone),
    Fax: norm(sc.Fax),
    Email: norm(sc.Email),
    Email_Alternate__c: norm(sc.Email_Alternate__c),
    Personal_Email__c: norm(sc.Personal_Email__c),
    GMB_Type__c: norm(sc.Type),
    GMB_Region__c: norm(sc.GMB_Region__c),
    MailingStreet: norm(sc.MailingAddress?.street),
    MailingCity: norm(sc.MailingAddress?.city),
    MailingState: norm(sc.MailingAddress?.state),
    MailingPostalCode: norm(sc.MailingAddress?.postalCode),
    MailingCountry: norm(sc.MailingAddress?.country),
    OtherStreet: norm(sc.OtherAddress?.street),
    OtherCity: norm(sc.OtherAddress?.city),
    OtherState: norm(sc.OtherAddress?.state),
    OtherPostalCode: norm(sc.OtherAddress?.postalCode),
    OtherCountry: norm(sc.OtherAddress?.country),
    GMB_Account_Billing_State_Short_Code__c: norm(sc.GMB_Account_Billing_State_Short_Code__c)
  };
};

